import TeamTabs from "../components/UI/TeamTabs/TeamTabs";

export default function Team() {
	return <TeamTabs />;
}
